import React, { PropTypes } from 'react';
import Dropzone from 'react-dropzone';
import { byteToMegabyte } from '../helpers/helpers';
import moment from "moment";
import 'moment-timezone';

const timezone = 'America/New_York';

const FileSubmission = (props) => {
    let dropzone_ref;

    let isUploaded = function (filename) {
        for (let i = 0, l = props.submission.submission_files.length; i < l; i++) {
            let submission_file = props.submission.submission_files[i];
            if (submission_file.name === filename &&
                (
                    submission_file.progress === undefined ||
                    submission_file.progress === 100
                )
            ) {
                  return true;
            }
        }
        return false;
    };

    let isAdditional = function (filename) {
        for (let i = 0, l = props.assignment.assignment_filenames.length; i < l; i++) {
            if (props.assignment.assignment_filenames[i].name === filename) {
                return false;
            }
        }
        return true;
    };

    let isRequired = function (filename){
        for (let i = 0, l = props.assignment.assignment_filenames.length; i < l; i++) {
            if (props.assignment.assignment_filenames[i].name === filename &&
                props.assignment.assignment_filenames[i].optional === false) {
                return true;
            }
        }
        return false;
    };

    let isOptional = function (filename) {
        for (let i = 0, l = props.assignment.assignment_filenames.length; i < l; i++) {
            if (props.assignment.assignment_filenames[i].name === filename &&
                props.assignment.assignment_filenames[i].optional === true) {
                return true;
            }
        }
        return false;
    };

    let getSubmissionFile = function (filename) {
        const { submission } = props,
            { submission_files } = submission
        ;

        if (submission_files) {
            for (let i = 0, l = props.submission.submission_files.length; i < l; i++) {
                let submission_file = props.submission.submission_files[i];
                if (submission_file.name === filename) {
                    return submission_file;
                }
            }
        }

        return undefined;
    };

    let assignment_filename = function (assignment_filename, i) {
        let file = getSubmissionFile(assignment_filename.name);
        return (
            (props.display === 'required' && assignment_filename.optional === false) ||
            (props.display === 'optional' && assignment_filename.optional === true)
            ? (
                <div id={props.display + "_assignment_filenames" + i} 
                     className={`uploaded-file mb-2 ${assignment_filename.description && assignment_filename.description.trim() !== '' ? 'file-with-description' : ''}`}
                     key={"file_" + assignment_filename.name}>
                    {
                        file
                        ? (
                            [file].map(submission_file)
                        ) : (
                            <div key={'fixed_' + assignment_filename.id}>
                                {assignment_filename.description && assignment_filename.description.trim() !== '' && (
                                    <div className="file-description">
                                        {assignment_filename.description}
                                    </div>
                                )}
                                {assignment_filename.name}
                                <span className="progress">
                                    <div key=
                                        {'fixed_' + assignment_filename.id}
                                        className="progress-bar"
                                        style={{width:'0%'}}
                                        role="progressbar"
                                    />
                                </span>
                            </div>
                        )
                    }
                </div>
            )
            : (
                null
            )
        );
    };

    let submission_file = function(submission_file, i) {
        let prefix = props.display === 'additional' ? 'additional_' : 'fixed_';
        let assignmentFilename = props.assignment.assignment_filenames.find(af => af.name === submission_file.name);
        return (
            (props.display === 'required' && isRequired(submission_file.name)) ||
            (props.display === 'optional' && isOptional(submission_file.name)) ||
            (props.display === 'additional' && isAdditional(submission_file.name))
            ? (
                isUploaded(submission_file.name) === true
                ? (
                    <div key={submission_file.id} 
                         className={props.disabled ? 'disabled-overlay' : ''}>
                        {assignmentFilename && assignmentFilename.description && assignmentFilename.description.trim() !== '' && (
                            <div className="file-description">
                                {assignmentFilename.description}
                            </div>
                        )}
                        <button
                            className="btn-link download-file"
                            key={submission_file.id + "_download"}
                            id={submission_file.id}
                            name={submission_file.name}
                            onClick={props.onDownloadFile}
                            disabled={props.disabled}
                        >
                            <i
                                className="fa fa-download"
                                aria-hidden="true" id={submission_file.id}
                                name={submission_file.name}
                            /> {submission_file.name}
                        </button>
                        <span> - {byteToMegabyte(submission_file.size)}</span>
                        <div className="float-right">
                            {
                                moment(submission_file.updated).tz(timezone).format('MM-DD-YYYY h:mm:ss a')
                            }
                            &nbsp;
                            {
                                props.downloadOnly === true
                                ? null
                                : (
                                    !props.disabled && (!assignmentFilename || !assignmentFilename.prevent_deletion)
                                    ?
                                    <i
                                        onClick={props.onRemoveFile}
                                        id={submission_file.id}
                                        className={`fa fa-times-circle red`}
                                    />
                                    : null
                                )
                            }
                        </div>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped bg-success"  style={{width:'100%'}} role="progressbar">Uploaded</div>
                        </div>
                    </div>
                )
                : (
                    <div key={prefix + submission_file.id}>
                        {submission_file.name}
                        <span className="progress">
                            {
                                submission_file.progress === 0
                                ? (
                                    <div
                                        key={prefix + submission_file.id}
                                        className="bg-warning progress-bar progress-bar-animated progress-bar-striped"
                                        style={{width:'100%'}}
                                        role="progressbar"
                                    >
                                        Uploading...
                                    </div>
                                )
                                : (
                                    submission_file.progress === -1
                                    ? (
                                        <div
                                            key={prefix + submission_file.id}
                                            className="bg-danger progress-bar progress-bar-striped"
                                            style={{width:'100%'}}
                                            role="progressbar"
                                        >
                                            Error
                                        </div>
                                    )
                                    : (
                                        <div
                                            key={prefix + submission_file.id}
                                            className="progress-bar"
                                            style={{width:'0%'}}
                                            role="progressbar"
                                        />
                                    )
                                )
                            }
                        </span>

                    </div>
                )
            )
            : (
               null
            )
        );
    };

    return (
        <div className="card">
            <div className="card-block no-gutters message">
                <Dropzone className="dropzone row no-gutters"
                    onDrop={
                        props.display === 'additional'
                        ? (
                            props.onDropAdditionalFile
                        )
                        : (
                            props.onDropFixedFilename
                        )
                    }
                    disableClick={true}
                    ref={(node) => { dropzone_ref = node; }}
                >
                    <b>{props.label}</b>
                    <div className="offset-sm-8 col-sm-4 mb-3">
                        {
                            props.downloadOnly === true
                            ? null
                            : (
                                props.uploadAllowed === true &&
                                props.submission.id &&
                                props.submission.id !== "-1"
                                ? (
                                    <button
                                        type="button"
                                        onClick={() => { dropzone_ref.open(); }}
                                        className="btn btn-sm btn-primary float-right"
                                    >
                                        Upload file <i className="fa fa-upload"/>
                                    </button>
                                )
                                : (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary float-right"
                                        disabled
                                        title={
                                            props.assignment.group_submission && props.submission.id === "-1"
                                                ? "You must create a group before you can submit the assignment."
                                                : null
                                        }
                                    >
                                        Upload file <i className="fa fa-upload"/>
                                    </button>
                                )
                            )
                        }
                    </div>
                    <div className="col-sm-12 loading-content">
                        {
                            props.display === 'additional'
                            ? (
                                props.submission.submission_files.map(submission_file)
                            )
                            : (
                                props.assignment.assignment_filenames.map(assignment_filename)
                            )
                        }
                    </div>
                </Dropzone>
            </div>
        </div>
    );
};

FileSubmission.propTypes = {
    downloadOnly: PropTypes.bool,
    onDropFixedFilename: PropTypes.func.isRequired,
    onDropAdditionalFile: PropTypes.func.isRequired,
    display: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    submission: PropTypes.object,
    assignment: PropTypes.object,
    onDownloadFile: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    uploadAllowed: PropTypes.bool,
    disabled: PropTypes.bool
};

export default FileSubmission;



/** WEBPACK FOOTER **
 ** ./src/components/FileSubmission.js
 **/